import React from "react";
import { Star } from "lucide-react";
import { FadeUp } from "@/components/motion/Reveal";

const reviews = [
  {
    quote:
      "I put off life insurance for years because it felt overwhelming. Advanced Life Policies made it a two-minute thing — and I'm saving $38 a month.",
    name: "Marisol R.",
    role: "New parent, Austin",
  },
  {
    quote:
      "No pushy salesperson, no medical exam, no nonsense. Just a straight answer and a genuinely great rate.",
    name: "Daniel K.",
    role: "Small-business owner",
  },
  {
    quote:
      "The savings estimator showed me exactly what I'd pay before I gave any details. That kind of honesty won me over instantly.",
    name: "Priya N.",
    role: "Teacher, Denver",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="bg-cream py-24 lg:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        {/* Image */}
        <FadeUp className="lg:col-span-5">
          <div className="relative">
            <div className="arch-top rounded-b-[2rem] overflow-hidden shadow-[0_40px_80px_-30px_rgba(15,23,42,0.35)] border border-forest/10">
              <img
                src="https://images.pexels.com/photos/7233031/pexels-photo-7233031.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Mature couple enjoying a sunny afternoon under a clear blue sky"
                className="w-full h-[520px] object-cover"
                data-testid="testimonial-image"
              />
            </div>
            <div className="absolute -bottom-6 left-6 rounded-2xl bg-forest text-cream px-6 py-4 shadow-xl">
              <p className="font-serif text-3xl leading-none">12,480+</p>
              <p className="text-xs uppercase tracking-[0.16em] text-cream/70 mt-1">families protected</p>
            </div>
          </div>
        </FadeUp>

        {/* Reviews */}
        <div className="lg:col-span-7">
          <FadeUp>
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-sage">Loved by families</span>
            <h2 className="mt-4 font-serif font-light text-forest text-4xl sm:text-5xl leading-[1.0] tracking-tight max-w-xl">
              Peace of mind, trusted by thousands.
            </h2>
          </FadeUp>

          <div className="mt-10 space-y-5">
            {reviews.map((r, i) => (
              <FadeUp key={i} delay={i * 0.1}>
                <div
                  className="rounded-2xl border border-forest/10 bg-sand/60 p-6 lg:p-7 transition-all duration-500 hover:-translate-y-1 hover:shadow-lg"
                  data-testid={`testimonial-card-${i}`}
                >
                  <div className="flex gap-1 text-terracotta">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} className="h-4 w-4 fill-terracotta" />
                    ))}
                  </div>
                  <p className="mt-3 font-serif text-xl lg:text-2xl text-forest/90 leading-snug italic">{`\u201C${r.quote}\u201D`}</p>
                  <p className="mt-4 text-sm font-semibold text-forest">
                    {r.name} <span className="font-normal text-forest/55">· {r.role}</span>
                  </p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
